import { DatePicker } from "antd";
import React from "react";
import { useLocation } from "react-router-dom";

const DatePickerField = ({ selectedDate, blockedDate, onChange }) => {
  const location = useLocation();
  const currentPath = location.pathname.replace("/", "");

  const dateValue =
    currentPath === process.env.REACT_APP_ECC && selectedDate
      ? selectedDate
      : null;
  const isDisabled =
    currentPath === process.env.REACT_APP_ECC &&
    blockedDate?.status === process.env.REACT_APP_BLOCK_STATUS;
  return (
    <DatePicker
      value={dateValue}
      onChange={onChange}
      disabled={isDisabled}
      allowClear={true} // optional: allows clearing the date
      placeholder="Select date"
      className="form-control rounded-md d-inline-flex"
    />
  );
};

export default DatePickerField;
